// Utils
import { GetDialingCode } from "./GetDialingCode";

type InstanceType = 'withLogin' | 'withoutLogin';

type dialingCodeObject = {
    dialingCode: string;
    displayName: string;
}

class DialingCode {
    static instances = {};
    static dialingCode = {};

    getDialingCodeValue = (attribute: InstanceType) => {
        if (DialingCode.instances[attribute]) {
            return DialingCode.dialingCode[attribute]
        }
        DialingCode.instances[attribute] = this;
        DialingCode.dialingCode[attribute] = GetDialingCode();

        return DialingCode.dialingCode[attribute];
    };

    clearInstanceAndDialingCode = () => {
        DialingCode.instances = {};
        DialingCode.dialingCode = {};
    }
}

let DialingCodeInstance: DialingCode | null = new DialingCode();

export const GetDialingCodeWithoutAuth = () => {
    if (DialingCodeInstance === null) {
        DialingCodeInstance = new DialingCode();
    }
    const DialingCodePrefixWithoutAuth: dialingCodeObject = DialingCodeInstance?.getDialingCodeValue('withoutLogin');

    return DialingCodePrefixWithoutAuth;
};

export const GetDialingCodeWithAuth = () => {
    if (DialingCodeInstance === null) {
        DialingCodeInstance = new DialingCode();
    }
    const DialingCodePrefixWithAuth: dialingCodeObject = DialingCodeInstance?.getDialingCodeValue('withLogin');

    return DialingCodePrefixWithAuth;
};

export const ClearDialingCodeInstance = () => {
    DialingCodeInstance?.clearInstanceAndDialingCode();
    DialingCodeInstance = null;
};


